module.exports = __webpack_public_path__ + "media/images/img-car-4-3f674a1f.png";